<div class="sidebar" [class.collapsed]="isCollapsed">
  <div class="sidebar-header">
    <div class="app-logo">
      <div class="logo-icon">
        <mat-icon>grid_view</mat-icon>
      </div>
      @if (!isCollapsed) {
      <span class="logo-text">Grilles Horaires</span>
      }
    </div>
  </div>

  <div class="sidebar-content">
    <mat-nav-list>
      @for (item of rootRoutes; track $index) {
      <a mat-list-item (click)="onMenuClick(item.path)" [attr.data-cy]="item['data-cy']"
        [matTooltip]="isCollapsed ? item.label : ''" matTooltipPosition="right">
        <mat-icon matListItemIcon>{{ item.icon }}</mat-icon>
        @if (!isCollapsed) {
        <span matListItemTitle>{{ item.label }}</span>
        }
      </a>
      }
    </mat-nav-list>
  </div>


  <div class="sidebar-bottom">

    <mat-nav-list>
      <a mat-list-item [matMenuTriggerFor]="menu" data-cy="nav-organization-school"
        [matTooltip]="isCollapsed ? 'Organisation école' : ''" matTooltipPosition="right">
        <mat-icon matListItemIcon> settings </mat-icon>
        @if (!isCollapsed) {
        <span matListItemTitle>Organisation école</span>
        }
      </a>
      <mat-menu #menu="matMenu">
        @for (item of organizationRoutes; track $index) {
        <button mat-menu-item (click)="onMenuClick(item.path)" [attr.data-cy]="item['data-cy']">
          <span>{{ item.label }}</span>
        </button>
        }
      </mat-menu>
    </mat-nav-list>
  </div>

  <div class="sidebar-footer">
    <div class="toggle-container" [class.collapsed]="isCollapsed">
      <button class="toggle-button" (click)="toggleCollapse()"
        [matTooltip]="isCollapsed ? 'Étendre la navigation' : ''" matTooltipPosition="right">
        <mat-icon>{{ isCollapsed ? 'view_sidebar' : 'keyboard_double_arrow_left' }}</mat-icon>
        @if (!isCollapsed) {
          <span class="toggle-label">Réduire la navigation</span>
        }
      </button>
    </div>
  </div>
</div>